import React, { ReactNode } from "react";

type TabProps = {
  children: ReactNode;
};
const ItemWrapper = ({ children }: TabProps) => {
  return (
    <div className="wrapper card">
      <div className="card-body">{children}</div>
    </div>
  );
};

export default ItemWrapper;
